import { configureStore } from '@reduxjs/toolkit'
import pipelineReducer from '@/features/adp/state/pipelineSlice'
import overlayReducer from '@/features/adp/state/overlaySlice'
import canvasReducer from '@/features/adp/state/canvas/canvasSlice'
import validationReducer from '@/features/adp/state/validationSlice'
import jobMonitoringReducer from '@/state/jobMonitoring.slice'
import { websocketMiddleware } from '@/lib/middleware/websocket.middleware'

export const store = configureStore({
  reducer: {
    pipeline: pipelineReducer,
    overlay: overlayReducer,
    canvas: canvasReducer,
    validation: validationReducer,
    jobMonitoring: jobMonitoringReducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(websocketMiddleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
